import { FORM_PROVIDER_API_APPENDIX } from 'constants/baseUrl';
import { api } from '.';

export const getForm = (formKey: string) => {
  return api.get$(`${FORM_PROVIDER_API_APPENDIX}/${formKey}`);
};
